export default __webpack_public_path__ + "static/media/fondo-desktop.2fbc2097.jpg";